import AuthLayout from '@components/Login/AuthLayout';
import SignInCard from '@components/Login/SignInCard';
import { ROUTE_PATHS } from '@constants/routes';
import { useAppSelector } from '@store/hooks';
import { Navigate } from 'react-router-dom';

const LoginPage = () => {
  const isAuthenticated = useAppSelector((state) => state.auth.isAuthenticated);

  if (isAuthenticated) return <Navigate to={ROUTE_PATHS.ACTIVATION} replace />;

  return (
    <AuthLayout>
      <SignInCard />
    </AuthLayout>
  );
};

export default LoginPage;
